module.exports = __webpack_public_path__ + "static/media/tiltfive.d1ec3ca1.jpg";